import axios from 'axios';
import { Fragment, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './Table.scss';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBackward, faClockRotateLeft, faPrint } from '@fortawesome/free-solid-svg-icons';

const identicals = [
  [1, 10, 19, 28, 37],
  [2, 11, 20, 29, 38],
  [3, 12, 21, 30, 39],
  [4, 13, 22, 31, 40],
  [5, 14, 23, 32, 41],
  [6, 15, 24, 33, 42],
  [7, 16, 25, 34, 43],
  [8, 17, 26, 35, 44],
  [9, 18, 27, 36, 45],
];

const Table = (props) => {
  const [drawsOfInterest, setDrawsOfInterest] = useState([]);
  const [drawSelected, setDrawSelected] = useState(null);
  const [previousDraw, setPreviousDraw] = useState(null);
  const [keyNumbers, setKeyNumbers] = useState([]);
  const numbers = useSelector((state) => state.form.numbers);
  const [fivePreviousDraws, setFivePreviousDraws] = useState([]);
  const [processed, setProcessed] = useState(false);
  const [numberExceptions, setNumberExceptions] = useState([]);
  const [keysFromLastDrawAppear, setKeysFromLastDrawAppear] = useState(false);
  const [whiteNumbers, setWhiteNumbers] = useState([]);

  const navigate = useNavigate();

  const draws = useSelector((state) => state.app.data);

  useEffect(() => {
    if (numbers.length <= 1) {
      navigate('/');
    }
  }, []);

  useEffect(() => {
    if (numbers.length > 0 && draws.length > 0) {
      const drawSelectedIndex = draws.findIndex((d) => d.winningNumbers.list.slice().sort().toString() === numbers.slice().sort().toString());

      const doi = [];

      if (drawSelectedIndex === -1) {
        setKeyNumbers(draws[0].winningNumbers.list);
      } else {
        setDrawSelected(draws[drawSelectedIndex]);
        const previousDrawOfDrawSelected = draws[drawSelectedIndex + 1];
        if (previousDrawOfDrawSelected) {
          setPreviousDraw(previousDrawOfDrawSelected);
          setKeyNumbers(previousDrawOfDrawSelected.winningNumbers.list);
        }
      }

      if (drawSelectedIndex > -1) {
        setFivePreviousDraws(draws.filter((d) => moment(d.date).isBefore(moment(draws[drawSelectedIndex].date))).slice(1, 6));

        const wn = []; // white numbers

        draws.filter((d) => moment(d.date).isBefore(moment(draws[drawSelectedIndex].date))).forEach((draw) => {
          let winningNumbersCount = 0;

          draw.winningNumbers.list.forEach((number) => {
            if (numbers.includes(number)) {
              winningNumbersCount++;
            }
          });

          if (winningNumbersCount >= 3) {
            draw.winningNumbers.list.forEach((number) => {
              if (!numbers.includes(number) && !draws[drawSelectedIndex + 1].winningNumbers.list.includes(number)) {
                wn.push(number);
              }
            });
          }

          if (winningNumbersCount === 3) {
            doi.push({
              ...draw,
              hasThree: true,
            });
          } else if (winningNumbersCount === 4) {
            doi.push({
              ...draw,
              hasFour: true,
            });
          } else if (winningNumbersCount === 5) {
            doi.push({
              ...draw,
              hasFive: true,
            });
          }
        });

        setWhiteNumbers(wn);
      } else {
        draws.forEach((draw) => {
          let winningNumbersCount = 0;

          draw.winningNumbers.list.forEach((number) => {
            if (numbers.includes(number)) {
              winningNumbersCount++;
            }
          });

          if (numbers.length === 2 && winningNumbersCount === 2) {
            doi.push({
              ...draw,
              hasTwo: true,
            });
          } else if (winningNumbersCount === 3) {
            doi.push({
              ...draw,
              hasThree: true,
            });
          } else if (winningNumbersCount === 4) {
            doi.push({
              ...draw,
              hasFour: true,
            });
          } else if (winningNumbersCount === 5) {
            doi.push({
              ...draw,
              hasFive: true,
            });
          }
        });
      }

      let keyAppears = false;
      doi.forEach((draw, i) => {
        draw.winningNumbers.list.forEach((number, j) => {
          if (draws[0].winningNumbers.list.includes(number) && !numbers.includes(number)) {
            keyAppears = true;
          }
        });
      });

      setKeysFromLastDrawAppear(keyAppears);

      setDrawsOfInterest(doi);
      setProcessed(true);
    }
  }, [draws, numbers]);

  const print = () => {
    window.print();
  };

  const toggleNumberException = (number) => {
    const newNumberExceptions = numberExceptions.slice();

    if (numberExceptions.includes(number)) {
      newNumberExceptions.splice(newNumberExceptions.indexOf(number), 1)
    } else {
      newNumberExceptions.push(number);
    }

    setNumberExceptions(newNumberExceptions);
  };

  const filteredDrawsOfInterest = drawsOfInterest.filter((draw) => {
    let hasExceptedNumber = false;

    for (let i = 0; i < draw.winningNumbers.list.length; i++) {
      hasExceptedNumber |= numberExceptions.includes(draw.winningNumbers.list[i]);

      if (hasExceptedNumber) {
        break;
      }
    }

    return !hasExceptedNumber;
  });

  return (
    <div className="Table">
      {
        processed && drawsOfInterest.length === 0 && <span>Δεν βρέθηκαν κληρώσεις που να συμπίπτουν οι αριθμοί {numbers.join(', ')}</span>
      }

      {
        drawsOfInterest.length > 0 && filteredDrawsOfInterest.length === 0 && <Fragment>
          <span>Εξαιρέθηκαν όλες οι κληρώσεις</span>
        </Fragment>
      }

      <div>
        <table>
          <tbody>
            {
              filteredDrawsOfInterest.map((draw, i) => {
                return (
                  <tr key={i}>
                    <td><div>{moment(draw.date).format('D-M-YYYY')}</div></td>
                    {
                      draw.winningNumbers.list.map((number, j) => {
                        let distanceEl;
                        const drawToCountDistance = drawSelected || draws[0];
                        if (!numbers.includes(number) && !keyNumbers.includes(number)) {
                          const distance = draws
                            .filter((d) => d.date < drawToCountDistance.date)
                            .findIndex((d) => d.winningNumbers.list.includes(number)) + 1 + 1;
                          distanceEl = <span className="distance">{distance}</span>;
                        }

                        return (
                          <td
                            key={j}
                          >
                            <div className={`${numbers.includes(number) ? (draw.hasThree ? 'number-from-triad' : (draw.hasFour ? 'number-from-quad' : (draw.hasFive ? 'number-from-quintet' : (draw.hasTwo ? 'number-from-pair' : '')))) : ''} ${keyNumbers.includes(number) ? 'key-number' : ''}`}>
                              {distanceEl}
                              {number}
                            </div>
                          </td>
                        );
                      })
                    }
                    <td><div className="bonus">{draw.winningNumbers.bonus[0]}</div></td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
          
        {
          whiteNumbers.length > 0 && <div class="white-numbers-table">
            {
              [1, 2, 3, 4, 5, 6, 7, 8, 9, 0].map((groupNumber, i) => {
                return (
                  <div>
                    {
                      Array.from(Array(5)).map((n, j) => {
                        const whiteNumber = whiteNumbers.find((n) => n % 10 === groupNumber && (n > j * 10 && n <= (j + 1) * 10));

                        return (
                          <span>{whiteNumber}</span>
                        );
                      })
                    }
                  </div>
                );
              })
            }
          </div>
        }
      </div>

      <div className="info">
        {
          drawSelected && <Fragment>
            <span>Κλήρωση: {moment(drawSelected.date).format('dddd D MMM YYYY')}</span>
            
            <div className="draw">
              {
                drawSelected && drawSelected.winningNumbers.list.map((number, i) => {
                  return (
                    <div key={i}>
                      {number}
                    </div>
                  );
                })
              }
              <div className="bonus">{drawSelected && drawSelected.winningNumbers.bonus[0]}</div>
            </div>
          </Fragment>
        }

        {
          drawSelected && <div className="identicals">
            {
              drawSelected.winningNumbers.list.map((number, i) => {
                const identicalsGroup = identicals.find((g) => g.includes(number));
                let whiteNumbersIdenticals = whiteNumbers.filter((n) => identicalsGroup.includes(n));
                whiteNumbersIdenticals = whiteNumbersIdenticals.filter((n, k) => whiteNumbersIdenticals.indexOf(n) === k);
                whiteNumbersIdenticals.sort((a, b) => {
                  if (a > b) {
                    return 1;
                  } else {
                    return -1;
                  }
                });

                return (
                  <div key={i}>
                    {
                      whiteNumbersIdenticals.map((identicalNumber, j) => {
                        return (
                          <span key={j}>{identicalNumber}</span>
                        );
                      })
                    }
                  </div>
                );
              })
            }
          </div>
        }

        {
          drawSelected && <div className="previous-draw">
            <span><FontAwesomeIcon icon={faBackward} size="lg" />&nbsp;Προηγούμενη κλήρωση</span>

            <div className="draw">
              {
                previousDraw.winningNumbers.list.map((number, i) => {
                  return (
                    <div key={i}>
                      {number}
                    </div>
                  );
                })
              }
              <div className="bonus">{previousDraw.winningNumbers.bonus[0]}</div>
            </div>
          </div>
        }

        {
          drawSelected && <div className="five-previous-draws">
            <span><FontAwesomeIcon icon={faClockRotateLeft} size="lg" />&nbsp;5 προηγούμενες κληρώσεις</span>

            {
              fivePreviousDraws.map((draw, i) => {
                return (
                  <div className="draw" key={i}>
                  {
                    draw.winningNumbers.list.map((number, j) => {
                      return (
                        <div key={j} className={`${whiteNumbers.includes(number) ? 'white-number' : ''}`}>
                          {number}
                        </div>
                      );
                    })
                  }
                  <div className="bonus">{draw.winningNumbers.bonus[0]}</div>
                </div>
                );
              })
            }
          </div>
        }

        {
          !drawSelected && <Fragment>
            {
              draws[0] && keysFromLastDrawAppear && <span className="info-text">Εμφανίζονται κλειδιά από την τελευταία κλήρωση {moment(draws[0].date).format('dddd D MMMM')}</span>
            }

            <div className="number-exceptions">
              <span className="label">Εξαιρέσεις Αριθμών</span>
              <div className="numbers">
                {
                  Array.from(Array(45)).map((n, i) => {
                    if (numbers.includes(i + 1)) {
                      return;
                    }

                    return (
                      <div
                        key={i}
                        className={`${numberExceptions.includes(i + 1) ? 'active' : ''}`}
                        onClick={toggleNumberException.bind(this, i + 1)}
                      >
                        {i + 1}
                      </div>
                    );
                  })
                }
              </div>
            </div>
          </Fragment>
        }
      </div>

      <button className="btn-print" onClick={print}><FontAwesomeIcon icon={faPrint} size="2x"></FontAwesomeIcon></button>
    </div>
  )
};

export default Table;
